export default __webpack_public_path__ + "static/media/element_29.53f39477.jpg";